import { useMutation } from '@tanstack/react-query';
import { postAttachment } from '../Services/ProcessedTimesheetService';

const usePostProcessedTimesheetAttachment = (options = {}) => useMutation(postAttachment, options);

export default usePostProcessedTimesheetAttachment;
